import React from "react";

function BookingFormSteps({ step, count }) {
  return (
    <div className="bookingCard__steps mob_hide">
      шаг {step == "contacts" && count} {step == "services" && "2"}{" "}
      {step == "1" && "1"} из {count}
    </div>
  );
}

export default BookingFormSteps;
